import React from "react";
import classes from "../ButtonLink/ButtonLink.module.scss";

// Interface que define as props do componente ButtonLink
interface ButtonLink {
    onClick?: () => void;
    disabled?: boolean; 
    className?: string;
    text?: string | null;
    type?: "button" | "submit" | "reset"; 
    children?: React.ReactNode;
}

// Componente ButtonLink: botão customizável com estilização via CSS Modules
export default function ButtonLink({
    onClick,
    disabled = false,
    className = "",
    type = "button",
    children
}: ButtonLink) {
    // Adiciona a classe CSS padrão do botão junto às classes passadas via prop
    className += " " + classes.BtnLink;

    return (
        <button
            className={className}
            onClick={onClick}
            disabled={disabled}
            type={type}
        >
            {children}
        </button>
    );
}
